import {gql} from 'apollo-angular';

export const UPDATE_API_KEY_MUTATION = gql`
mutation updateApiKey($apiKeyInput: ApiKeyInput) {
  updateApiKey(input: $apiKeyInput)
}
`;

export const CREATE_API_KEY_MUTATION = gql`
mutation createApiKey($apiKeyInput: ApiKeyInput) {
  createApiKey(input: $apiKeyInput){
    apiKeyId
    apiKeyData
  }
}
`;

export const DELETE_API_KEY_MUTATION = gql`
mutation deleteApiKey($apiKeyId: UUID) {
  deleteApiKey(id: $apiKeyId)
}
`;
